import { render, staticRenderFns } from "./AccountMyAccount.vue?vue&type=template&id=071a3909&"
import script from "./AccountMyAccount.vue?vue&type=script&lang=js&"
export * from "./AccountMyAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports